var ComparisonShiftDirectionEnum = /* @__PURE__ */ ((ComparisonShiftDirectionEnum2) => {
  ComparisonShiftDirectionEnum2["Left"] = "left";
  ComparisonShiftDirectionEnum2["Right"] = "right";
  return ComparisonShiftDirectionEnum2;
})(ComparisonShiftDirectionEnum || {});
export {
  ComparisonShiftDirectionEnum
};
